exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".skeleton-workspace-history[data-v-5b83340a]{display:flex;align-items:flex-start}.skeleton-workspace-history .skel-workspace-history-avatar[data-v-5b83340a]{margin-right:.375rem}.skeleton-workspace-history .skel-workspace-history-info[data-v-5b83340a]{flex:1}.skeleton-workspace-history .skel-workspace-history-info .skel-workspace-history-row-alpha[data-v-5b83340a]{margin-bottom:.475rem}", ""]);

// exports
